/*eslint react-hooks/exhaustive-deps: "off"*/
import publicIp from 'public-ip';
import { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { UrlBase, URL_PLUGIN, URL_RETORNO } from 'src/parametros';
import { POST } from 'src/services';

const useGenerarUrlPTP = ({ initialFetch = true, onComplete, onError }) => {
  const {
    idCotizacion,
    titular,
    producto,
    valoresPagar,
    empPtp,
    broker,
    moneda,
    ivageneral
  } = useSelector((state: any) => state.Cotizacion.cotizacion);
  
  let agrupacion = 'titular'
  const [datosPersonales, setDatosPersonales] = useState({
    identificacion: titular.identificacion || titular[agrupacion].identificacion,
    cedula: titular.identificacion || titular[agrupacion].identificacion,
    nombre1: `${titular.nombre1 || titular[agrupacion].nombre1}  ${titular?.nombre2 || titular[agrupacion]?.nombre2 || ""}`,
    apellido1: `${titular.apellido1 || titular[agrupacion].apellido1} ${titular?.apellido2 || titular[agrupacion]?.apellido2 || ""}`,
    email: titular.email || titular[agrupacion].email,
    celular: titular.celular || titular[agrupacion].celular,
    primerNombre: `${titular.nombre1 || titular[agrupacion].nombre1}`,
    segundoNombre: `${titular?.nombre2 || titular[agrupacion]?.nombre2 || ""}`,
    primerApellido: `${titular.apellido1 || titular[agrupacion].apellido1}` || "",
    segundoApellido: `${titular?.apellido2 || titular[agrupacion]?.apellido2} ` || ""
  })

  const [loading, setLoading] = useState(false);
  const [response, setResponse] = useState(null);

  const [error, setError] = useState(null);

  const init = useCallback(async () => {
    setLoading(true);
    setError(null);
    setResponse(null);

    let body = null;
    let URL = null;
    let key = null;
    switch (producto.periocidadPago) {
      case 'Unico':
        body = {
          empresa: empPtp,
          adicional: idCotizacion,
          plataforma: 'WEB',
          cliente: {
            cliIdentificacion: datosPersonales.identificacion,
            cliNombre1: datosPersonales.nombre1,
            cliApellido1: datosPersonales.apellido1,
            cliEmail: datosPersonales.email,
            cliCelular: datosPersonales.celular,
          },
          pagador: {
            pagIdentificacion: datosPersonales.identificacion,
            pagNombre1: datosPersonales.primerNombre,
            pagNombre2: datosPersonales.segundoNombre,
            pagApellido1: datosPersonales.primerApellido,
            pagApellido2: datosPersonales.segundoApellido,
            pagEmail: datosPersonales.email,
            pagCelular: datosPersonales.celular,
          },
          imp: valoresPagar.impuestos,
          subt: valoresPagar.subtotal,
          iva12: ivageneral,
          monto: valoresPagar.total,
          moneda: moneda?.sigla ?? 'USD',
          descripcion: `${producto.nombre} - #${idCotizacion}`,
        };
        URL = `${UrlBase}frontend/web/index.php?r=placetopay/peticion-pago-ptp-generico`;
        key = 'traUrl';
        break;
      case 'Indefinido':
      case 'Mensual':
        body = {
          empresa: empPtp,
          cedula: datosPersonales.identificacion,
          nombre: datosPersonales.nombre1,
          apellido: datosPersonales.apellido1,
          email: datosPersonales.email,
          celular: datosPersonales.celular, //ESTE PARAMETRO DEBE CUMPLIR CON CIERTA LONGITUD SINO DA ERROR
          idreferencia: idCotizacion,
          descripcion: `${producto.nombre} - #${idCotizacion}`,
          plataforma: 'WEB',
          monto: valoresPagar.total,
          impuestos: valoresPagar.impuestos,
          subtotal: valoresPagar.subtotal,

          pagIdentificacion: datosPersonales.identificacion,
          pagNombre1: datosPersonales.primerNombre,
          pagApellido1: datosPersonales.primerApellido,
          pagEmail: datosPersonales.email,
          pagCelular: datosPersonales.celular, //ESTE PARAMETRO DEBE CUMPLIR CON CIERTA LONGITUD SINO DA ERROR

          //url_retorno: `http://microsegurosdemo.us-east-2.elasticbeanstalk.com/fin-suscripcion/${idCotizacion}/`,
          url_retorno: `${URL_RETORNO}fin-suscripcion/${idCotizacion}/`,
          //url_retorno: `http://10.55.1.137:3000/fin-suscripcion/${idCotizacion}/`,
          ipAddress: await publicIp.v4(),
          urlCallback: `${URL_PLUGIN}actualiza-estado-cotizacion&empresa=${broker}&idReferencia=${idCotizacion}`,
          coleccion: 'cotizaciones',
          realizarCobroDolar: true,
        };

        URL = `${UrlBase}frontend/web/index.php?r=placetopay/peticion-suscripcion-ptp-generico`;
        key = 'pagUrl';
        break;
      default:
        break;
    }

    const res = await POST(URL, body);

    console.log(URL, '\n', body, res);

    if (res.transaccion && !res.error) {
      console.log(res);
      const data = {
        url: res[key],
      };
      setResponse(res.data);
      onComplete && (await onComplete(data));
    } else {
      onError && (await onError(res));
    }

    setLoading(false);
  }, []);

  useEffect(() => {
    if (initialFetch) {
      init();
    }
  }, [init, initialFetch]);

  return {
    generarUrlPtp: init,
    loadingUrlPtp: loading,
    responseUrlPtp: response,
    errorUrlPtp: error,
  };
};

export default useGenerarUrlPTP;
